import React from 'react'
import {observer} from 'mobx-react'
import {Slot} from '../Slot'
import {SlotContentItem} from '../../../types/cms'
import {useBasketStore, useContentStore, useRapidDeliveryStore} from '../../../store/hooks/useStore'
import {hasAvailableDeliveryBannerContent} from './availability'

interface DeliveryBannerSlotProps {
  data?: SlotContentItem
}

export const DeliveryBannerSlot = observer(({data}: DeliveryBannerSlotProps) => {
  const {params} = useContentStore()
  const {deliveryPostalCode} = useBasketStore()
  const {isRapidDeliveryAvailableForPostcode, rapidDeliveryAvailabilityResolved} = useRapidDeliveryStore()

  const isVariationEligible = (contentItems: SlotContentItem['default'] = []) =>
    hasAvailableDeliveryBannerContent(contentItems, params, {
      available: isRapidDeliveryAvailableForPostcode,
      resolved: rapidDeliveryAvailabilityResolved,
      postcode: deliveryPostalCode,
    })

  return <Slot data={data} isVariationEligible={isVariationEligible} />
})